module.exports = __webpack_public_path__ + "img/关联定义统计.1b1c330c.svg";